const chains = [];
chains.push({ _operation: 'activateUserPermissionById', api: '/user/:userId/permission/:objectId/activate', defaultData: null, httpVerb: 'put' });
chains.push({ _operation: 'deactivateUserPermissionById', api: '/user/:userId/permission/:objectId/deactivate', defaultData: null, httpVerb: 'put' });
chains.push({ _operation: 'getUserPermissionsByUserId', api: '/user/:userId/permissions', defaultData: [], httpVerb: 'get' });
export default chains;
